import { fetchData } from "./fetchData";

export const getAllGames = async (query) => {
  let route = `/games${query}`;
  console.log(route);
  // if(season) route += `&season=${season}`; //season will default on server-side if not provided

  const options = {
    method: "GET",
  };

  let response = await fetchData(route, options);
  console.log(response);
  return response;
};

export const getGameByID = async (gameID) => {
  try {
    let route = `/games/${gameID}`;

    let options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
    //need an error handler
  }
};

export const createGame = async (formData) => {
  try {
    const route = `/games`;

    const options = {
      method: "POST",
      Headers: {
        "Content-Type": "application/json",
      },
      body: formData,
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const updateGame = async (id, formData) => {
  try {
    const route = `/games/${id}`;

    const options = {
      method: "PUT",
      Headers: {
        "Content-Type":
          formData instanceof FormData ? "multipart/form-data" : "application/json",
      },
      body: formData,
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const searchGames = async (query) => {
  try {
    const route = `/games/options/search?search=${query}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};
